import script from "./FormCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./FormCheckbox.vue?vue&type=style&index=0&id=f1e910cc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1e910cc"]])

export default __exports__